export const FILTER_AND_SEARCH_B_TEMPLATE_ID = '43bf8423-58e1-4a30-9004-72831ae63a4e';
